import React, { useRef, useState } from 'react';
import EventTypePicker from './EventTypePicker';
import './TreeEvent.css';
import { EVENT_TYPE_ICONS, EVENT_TYPES } from './eventTypeIcons';
import TreeEventLDModal from './TreeEventLDModal'; // <-- import the modal component
import getCountriesBoundingBox from './countryBounds'; // <-- import the bounding box function

function TreeEvent({
  event, onMapIconClick, onEdit, onDelete, isEditing, onEditChange, onEditSave, onEditCancel, onEditTypeChange,
  onEditMapPicker, onAttachDocument, onDoubleClick, attachedFile, editingLocation, showAddMode, isSelected, onClick, userLayer,
  onEditLongDescription, trip, onAttachView, isOwner, isMultiSelectMode, isSelectedRouteEvent
}) {
  const fileInputRef = useRef();
  const longPressTimeout= useRef();
  const [fileAttachingEdit, setFileAttachingEdit] = useState(false);
  const [showLongDescModal, setShowLongDescModal] = useState(false);
  const [longDescDraft, setLongDescDraft] = useState(event.longDescription || '');
  const [isViewOnlyModal, setIsViewOnlyModal] = useState(false);

  const handleAttachClick = (e) => {
    e.stopPropagation();
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const maxSize = (userLayer && userLayer >= 2) ? 4 * 1024 * 1024 : 2 * 1024 * 1024;
      if (file.size > maxSize) {
        alert(`File size must be ${userLayer && userLayer >= 2 ? '4MB' : '2MB'} or less.`);
        e.target.value = '';
        return;
      }
      onAttachDocument && onAttachDocument(file);
      setFileAttachingEdit(true);
      e.target.value = '';
    }
  };

  const hasLocation = (isEditing || showAddMode)
    ? (editingLocation && editingLocation.name)
    : (event.location && event.location.name);

  let hasAttachedFile = false;
  if (showAddMode) {
    hasAttachedFile = !!attachedFile;
  }

  // Handler for opening the long description modal in view mode (mobile only)
  const handleLongDescViewClick = (e) => {
    e.stopPropagation();
    setLongDescDraft(event.longDescription || '');
    setIsViewOnlyModal(true);
    setShowLongDescModal(true);
  };

  // Handler for opening the long description modal
  const handleLongDescClick = (e) => {
    e.stopPropagation();
    setLongDescDraft(event.longDescription || '');
    setIsViewOnlyModal(false);
    setShowLongDescModal(true);
  };

  // Handler for saving the long description
  const handleLongDescSave = () => {
    if (onEditLongDescription) {
      onEditLongDescription(longDescDraft);
    }
    setShowLongDescModal(false);
  };

  const setMapToInitialBounds = async () => {
    const boundsOrCenter = await getCountriesBoundingBox(trip.countries, trip.cities);
      if (boundsOrCenter) {
        if (boundsOrCenter.bounds) {
          onMapIconClick('', boundsOrCenter.bounds, null, null, false);
        } else {
          onMapIconClick('', boundsOrCenter.lat, boundsOrCenter.lng, boundsOrCenter.zoom, false);
        }
  }
}

  

  return (
    <div
      className={
        'tree-event' +
        ((isEditing || showAddMode || isSelected) ? ' selected' : '') +
        ((isEditing || showAddMode) ? ' editing' : '') +
        (isMultiSelectMode && isSelected ? ' multi-select' : '')
      }
      onClick={e => {
        if (onClick) onClick(e);
          if (!isEditing && !showAddMode && onMapIconClick && event.location && event.location.name && event.location.lat != null && event.location.lng != null) {
          const zoom = event.location.zoom != null ? event.location.zoom : 15;
          onMapIconClick(event.location.name, event.location.lat, event.location.lng, zoom, false);
        } else if (!isEditing && !showAddMode && onMapIconClick && event.eventType !== 'Route') {
          setMapToInitialBounds();
        }
      }}
      onDoubleClick={event.media ? (e => { e.stopPropagation(); onDoubleClick && onDoubleClick(event); }) : undefined}
      onTouchStart={e => {
        e.preventDefault();
        if (window.innerWidth > 600 || !event.media || !onAttachView) return;
        longPressTimeout.current = setTimeout(() => {
          if (
            onMapIconClick &&
            event.location &&
            event.location.name &&
            event.location.lat != null &&
            event.location.lng != null
          ) {
            const zoom = event.location.zoom != null ? event.location.zoom : 15;
            onMapIconClick(event.location.name, event.location.lat, event.location.lng, zoom, false);
          } else if (onMapIconClick) {
            setMapToInitialBounds();
          }
          onAttachView(event); // Open event viewer instead of double click on mobile
        }, 500);
      }}
      onTouchEnd={e => {
        if (longPressTimeout.current) {
          clearTimeout(longPressTimeout.current);
          e.stopPropagation();
        }
      }}
      onTouchMove={e => {
        if (longPressTimeout.current) {
          clearTimeout(longPressTimeout.current);
          e.stopPropagation();
        }
      }}
      onContextMenu={e => { if (window.innerWidth <= 600) e.preventDefault(); }}
    >
      {(event.media || (isEditing && attachedFile) || (showAddMode && attachedFile)) && (
        <span
          className="tree-attachment-icon"
          title="Has Attachment"
          style={{ marginRight: 1, color:  '#b5cea8', fontSize: '1.1em', verticalAlign: 'middle', cursor: (!isEditing && !showAddMode && event.media) ? 'pointer' : 'default' }}
          onClick={e => {
            if (!isEditing && !showAddMode && event.media && onDoubleClick) {
              e.stopPropagation();
              onAttachView(event); // need to change the name as double clic will change behaivor 
            }
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={ '#b5cea8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3 3 0 0 1 4.24 4.24l-9.19 9.19a1 1 0 0 1-1.41-1.41l9.19-9.19"/></svg>
        </span>
      )}
            {window.innerWidth <= 600 && event.longDescription && event.longDescription.trim() !== '' && event.longDescription !== '<br>' && (
              <span
                className="tree-longdesc-view-icon"
                title="View Description"
                style={{
                  cursor: 'pointer',
                  fontSize: '1.1em',
                  color: '#228B22'
                }}
                onClick={handleLongDescViewClick}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#228B22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="2" width="16" height="20" rx="2" />
                  <line x1="9" y1="9" x2="15" y2="9" />
                  <line x1="9" y1="13" x2="15" y2="13" />
                  <line x1="9" y1="17" x2="13" y2="17" />
                </svg>
              </span>
            )}

      {isEditing || showAddMode ? (
        <div
          id="tree-event-inline-mode"
          className="tree-add-form"
          style={{
            margin: 0,
            gap: 1,
            background: 'transparent',
            boxShadow: 'none',
            border: 'none',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }}
        >
          <EventTypePicker
            id="tree-event-type-picker"
            eventType={event.eventType}
            onPick={onEditTypeChange}
          />
          <input
            id='tree-event-edit-input'
            className="tree-event-edit-input"
            value={event.description}
            onChange={e => onEditChange(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') { setFileAttachingEdit(false); onEditSave(); }
              if (e.key === 'Escape') { setFileAttachingEdit(false); onEditCancel(); }
            }}
            autoFocus
            style={{ flex: 1, maxWidth: 320, minWidth: 80, marginRight: 2 }}
          />
          {/* Action buttons group: longdesc, map, attach, save, cancel */}
          <div className="tree-event-action-group" style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 8 }}>
            <span
              id='tree-event-longdesc-icon'
              className="tree-longdesc-icon"
              title="Add / Edit Description"
              style={{
                cursor: 'pointer',
                fontSize: '1.1em',
                color: (event.longDescription && event.longDescription.trim() !== '' && event.longDescription !== '<br>') ? '#228B22' : '#b5cea8'
              }}
              onClick={handleLongDescClick}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={(event.longDescription && event.longDescription.trim() !== '' && event.longDescription !== '<br>') ? '#228B22' : '#b5cea8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="2" width="16" height="20" rx="2" />
                <line x1="9" y1="9" x2="15" y2="9" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="13" y2="17" />
              </svg>
            </span>
            <span
              id='tree-event-map-icon'
              className="tree-map-icon"
              title="Show on Map"
              style={{ cursor: 'pointer', fontSize: '1.1em', color: hasLocation ? '#228B22' : '#b5cea8' }}
              onClick={e => { e.stopPropagation(); onEditMapPicker && onEditMapPicker(event.description); }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={hasLocation ? '#228B22' : '#b5cea8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10.5a8.38 8.38 0 0 1-1.9 5.4c-1.5 2-4.1 4.6-6.1 6.1-2-1.5-4.6-4.1-6.1-6.1A8.38 8.38 0 0 1 3 10.5a9 9 0 1 1 18 0z"/><circle cx="12" cy="10.5" r="3.5"/></svg>
            </span>
            <span
              id='tree-event-attach-icon'
              className="tree-attach-icon"
              title="Attach Document"
              style={{ cursor: 'pointer', fontSize: '1.1em', color:  '#b5cea8' }}
              onClick={handleAttachClick}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={ ((event.media || fileAttachingEdit) && (isEditing || showAddMode)) ? '#228B22' : '#b5cea8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3 3 0 0 1 4.24 4.24l-9.19 9.19a1 1 0 0 1-1.41-1.41l9.19-9.19"/></svg>
              <input type="file" style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileChange} />
            </span>
            <button
              id='tree-event-save-btn'
              className="tree-edit-btn mini-btn"
              title="Save"
              style={{ marginLeft: 4 }}
              onClick={e => { e.stopPropagation(); setFileAttachingEdit(false); onEditSave(); }}
            >✔</button>
            <button
              id='tree-event-cancel-btn'
              className="tree-delete-btn mini-btn"
              title="Cancel"
              style={{ marginLeft: 2 }}
              onClick={e => { e.stopPropagation(); setFileAttachingEdit(false); onEditCancel(); }}
            >✖</button>
          </div>
        </div>
      ) : (
        <>
          <span className="tree-event-label">
            {EVENT_TYPE_ICONS[event.eventType] || EVENT_TYPE_ICONS.Other}
            <span style={{ marginLeft: 6 }}>
              {event.description || event.location?.name}
            </span>
          </span>
          {isOwner && (!isMultiSelectMode || isSelectedRouteEvent) && <button className="tree-edit-btn mini-btn" title="Edit Event" onClick={e => { e.stopPropagation();  onEdit && onEdit(); }}>✎</button>}
          {isOwner && (!isMultiSelectMode || isSelectedRouteEvent) && <button className="tree-delete-btn mini-btn" title="Delete Event" onClick={e => { e.stopPropagation(); onDelete && onDelete(); }}>🗑</button>}
        </>
      )}
      {/* Move modal outside conditional rendering so it works from both edit and view modes */}
      <TreeEventLDModal
        open={showLongDescModal}
        value={longDescDraft}
        onChange={setLongDescDraft}
        onSave={handleLongDescSave}
        onClose={() => {
          setShowLongDescModal(false);
          setIsViewOnlyModal(false); // Reset view mode when closing
        }}
        viewOnly={isViewOnlyModal}
      />
    </div>
  );
}

export default TreeEvent;